export interface IAnalyticsForAction {
  analytics?: IAnalyticsEvent;
}

export interface IAnalyticsEvent {
  eventName: string;
  eventParams: object | undefined;
}

export function analyicsForAction(eventName: string, eventParams?: object)
: IAnalyticsForAction {
    return {
        analytics: {
            eventName: eventName.slice(0, 40),
            eventParams,
        },
    };
}
